import { rgba } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  border-radius: ${({ theme }) => theme.spacing(3)};
  background: ${({ theme }) => theme.palette.background.default};
  overflow: hidden;
`;

export const Image = styled.img`
  width: 251%;

  ${({ theme }) => theme.breakpoints.up('xs')} {
    width: 251%;
  }
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 167%;
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 167%;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    width: 125%;
  }
  ${({ theme }) => theme.breakpoints.up('xl')} {
    width: 100%;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: ${({ theme }) => theme.spacing(6)};

  background: ${({ theme }) =>
    `linear-gradient(${rgba(theme.palette.common.black, 0.09)}, ${rgba(theme.palette.common.black, 0.09)}),
    linear-gradient(${rgba(theme.palette.common.white, 0.4)}, ${rgba(theme.palette.common.white, 0.4)})`};
`;

export const Dialog = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(6)};

  margin: ${({ theme }) => theme.spacing(6)};
  padding: ${({ theme }) => `${theme.spacing(8)} ${theme.spacing(10)}`};
  max-width: 44rem;

  background: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.spacing(3)};
  box-shadow: 0 8px 20px 0
    ${({ theme }) => rgba(theme.palette.common.black, 0.05)};

  text-align: center;
`;

export const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;
